import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import getHeaderHeight from '../../helpers/getHeaderHeight';
var ScrollListener = function ScrollListener() {
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var getSectionPXArr = function getSectionPXArr() {
    if ($('#page').length === 0) return [];
    var sectionArr = [];
    $('#page section').each(function () {
      if (!$(this).attr('id')) return;
      var _$$position = $(this).position(),
        top = _$$position.top;
      var bottom = top + $(this).outerHeight() - 1;
      sectionArr.push({
        id: $(this).attr('id').replace('article-', ''),
        top: top,
        bottom: bottom
      });
    });
    return sectionArr;
  };
  var handleOnScroll = function handleOnScroll() {
    if ($('#page').length === 0) return;
    var _document$getElementB = document.getElementById('page'),
      scrollHeight = _document$getElementB.scrollHeight;
    var scrollTop = $(window).scrollTop();
    var height = $(window).height();
    var percentage = scrollTop / (scrollHeight - height);
    percentage = getHeaderHeight() / $(window).height();
    if (percentage > 1) percentage = 1;
    $('#scroll-listener').css({
      'top': percentage * height + 'px'
    });
    var sectionArr = getSectionPXArr();
    sectionArr.forEach(function (x) {
      if (scrollTop + getHeaderHeight() >= x.top && scrollTop + getHeaderHeight() <= x.bottom) $.event.trigger('slug-update-on-scroll', x.id);
    });
  };
  useEffect(function () {
    $('html, body').scrollTop(0);
  }, [pathname]);
  useEffect(function () {
    $(window).on('scroll', handleOnScroll);
    $(document).on('sidebar-article-click', function (e, slug) {
      return sidebarArticleClick(slug);
    });
    return function () {
      $(window).off('scroll', handleOnScroll);
      $(document).off('sidebar-article-click', function (e, slug) {
        return sidebarArticleClick(slug);
      });
    };
  }, []);
  var sidebarArticleClick = function sidebarArticleClick(slug) {
    $('html, body').animate({
      scrollTop: $("#article-".concat(slug)).offset().top - getHeaderHeight() + 10
    }, 400);
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "scroll-listener",
    className: "scroll-listener"
  });
};
export default ScrollListener;